import React from 'react';
import PropTypes from 'prop-types';
import { Toast } from '@agconnections/grow-ui';
import PortalModal from 'components/Modals/PortalModal';

const RemoveProductModal = ({
  open,
  close,
  handleRemove,
  isRemoveLoading,
  setToastHasNotBeenClosed,
  toastHasNotBeenClosed,
  toastRenderContents
}) => {
  const handleCancel = () => {
    // Guard the optional toast setter (only the product list supplies it) so
    // Cancel always closes instead of throwing on undefined (CWFWEB-9683).
    setToastHasNotBeenClosed?.(false);
    close();
  };

  return (
    <PortalModal
      open={open}
      title="Remove Product?"
      close={handleCancel}
      cancelLabel="Cancel"
      confirmLabel="Remove"
      onCancel={handleCancel}
      type="error"
      onConfirm={handleRemove}
      isRemoveLoading={isRemoveLoading}
    >
      <div testId="product-removeModal" className="pr-6">
        <p>
          Are you sure you want to remove this product from your Product List?
        </p>
        <br />
        <p>
          Removing a product will not affect any associated records. Products
          can be re-added to your list by selecting “Add Product”.
        </p>
      </div>

      {toastHasNotBeenClosed && (
        <Toast
          icon="error"
          onClose={() => {
            setToastHasNotBeenClosed?.(false);
          }}
        >
          {toastRenderContents}
        </Toast>
      )}
    </PortalModal>
  );
};

RemoveProductModal.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  handleRemove: PropTypes.func.isRequired,
  isRemoveLoading: PropTypes.bool.isRequired,
  // Optional toast props — only the product list supplies them.
  setToastHasNotBeenClosed: PropTypes.func,
  toastHasNotBeenClosed: PropTypes.bool,
  toastRenderContents: PropTypes.node
};

RemoveProductModal.defaultProps = {
  setToastHasNotBeenClosed: undefined,
  toastHasNotBeenClosed: false,
  toastRenderContents: null
};

export default RemoveProductModal;
